<script setup lang="ts">
import { computed } from 'vue';

import { ICompetitionWithLabel, IResult } from '@pssa/types';

import { resultsHelper } from '@/helpers/displayResults';

import TableContainer from './TableContainer.vue';

const props = defineProps<{
  results: IResult[];
  currentCompetition: ICompetitionWithLabel | undefined;
  onRowClick: (resultId: string) => void;
}>();

const displayResults = computed(() => resultsHelper(props.results));
</script>

<template>
  <TableContainer>
    <thead>
      <tr>
        <th>#</th>
        <th class="u-left">Competitor</th>
        <th class="u-left">Class</th>
        <th>Score</th>
        <th>Points</th>
      </tr>
    </thead>
    <tbody>
      <template
        v-for="{ isVisitor, row, className, competitor, score, points, resultId } of displayResults"
      >
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <tr :class="[{ 'is-visitor': isVisitor }, { odd: row % 2 }]" @click="onRowClick(resultId)">
          <td>{{ row }}</td>
          <td class="u-left">{{ competitor }}</td>
          <td class="u-left">{{ className }}</td>
          <td>{{ score }}</td>
          <td>
            {{ points }}
            <slot v-bind="{ resultId }" />
          </td>
        </tr>
        <slot name="graph" v-bind="{ resultId }" />
      </template>
    </tbody>
  </TableContainer>
</template>
